import intl from "react-intl-universal";
import React from "react";
import moment from "moment";
import classNames from "classnames";
import styles from "./index.module.scss";
import { Card, Tag, Tooltip, message } from "antd";
import publicImg from "@/assets/images/discover/public.png";
import unpublic from "@/assets/images/discover/unpublic.png";
import computable from "@/assets/images/discover/computable.png";
import TextTooltip from "@/components/Tooltip/index";
import { useMemo } from "react";
import { setIsOpen } from "@/store/modules/user";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
	collectResource,
	cancelCollectResource,
} from "@/apis/discover";
import {
	StarFilled,
	StarOutlined,
	CloudDownloadOutlined,
	UserOutlined,
	FieldTimeOutlined,
	EyeOutlined
} from "@ant-design/icons";

const ResourceCard = ({ data, rows, changeData, isShowContributor = true, isShowView = false }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { userInfo } = useSelector((state) => state.user);
	const token = useMemo(() => userInfo?.token, [userInfo]);

	const goDetail = (id) => {
		navigate(`/discover/detail?id=${id}`)
		// window.open(`${process.env.PUBLIC_URL}/discover/detail?id=${id}`)
	}
	const goPage = (e) => {
		e.stopPropagation();
		window.location.href = `${process.env.PUBLIC_URL}/user?uuid=${data.contributors[0].uuid}`
	}
	const handelCollect = (e) => {
		e.stopPropagation();
		if (data.isFavorite) {
			cancelCollect()
		} else {
			collect();
		}
	}

	// 收藏资源
	const collect = () => {
		if (token) {
			collectResource({
				resourceUuid: data.resourceUuid,
			})
				.then((res) => {
					message.success(intl.get("Successful collection"));
					changeData(data.resourceUuid, true)
				})
				.catch((err) => { });
		} else {
			dispatch(setIsOpen(true));
		}
	};

	// 取消收藏资源
	const cancelCollect = () => {
		cancelCollectResource({
			resourceUuid: data.resourceUuid,
		})
			.then((res) => {
				message.success(intl.get("Uncollect successfully"));
				changeData(data.resourceUuid, false)
			})
			.catch((err) => { });
	};

	return <Card onClick={() => goDetail(data.resourceUuid)} key={data.resourceUuid} hoverable variant="borderless" className={styles.cardBox}>
		<div className={classNames(styles.titleBox, "flex_box flex_between align_center")}>
			<h3>{data.title || "未定义"}</h3>
			<div>
				{data.resourceType && (
					<Tooltip title={data.resourceType.typeName}>
						<img
							src={
								process.env.REACT_APP_API_AFFIX + data.resourceType.imgPath
							}
						/>
					</Tooltip>
				)}
				{data.secondType !== "OpenDataServices" &&
					data.secondType !== "OpenProcessServices" &&
					data.secondType !== "OpenWebApps" && (
						<Tooltip
							title={
								data.isDownloadable ? "Downloadable" : "Not downloadable"
							}
						>
							<img src={data.isDownloadable ? publicImg : unpublic} />
						</Tooltip>
					)}
				{data.isComputable && (
					<Tooltip title={"Computable"}>
						<img src={computable} />
					</Tooltip>
				)}
			</div>
		</div>
		<div className={styles.tagBox}>
			{data.tags.map(tag => <Tag key={tag.tagUuid} color={tag.style || "magenta"}>{tag.tag}</Tag>)}
		</div>
		<div className={styles.desBox} >
			<TextTooltip
				placement="right"
				text={data.description}
				lineClamp={rows}
			></TextTooltip>
		</div>

		<div className={classNames(styles.baseBox, "flex_box align_center")}>
			{
				isShowContributor && <React.Fragment>
					<Tooltip title={intl.get("Contributor")}>
						<div onClick={goPage} className={classNames(styles.spanBox, "flex_box align_center")}>
							<UserOutlined
								style={{
									color: "#722ed1",
								}}
							/>
							<a href="#"> {(data.contributors && data.contributors.length > 0) ? data.contributors[0].nickname : ""}</a>
						</div>
					</Tooltip>
					<i>|</i>
				</React.Fragment>
			}

			<Tooltip title={intl.get("Last Modifiled")}>
				<div className={classNames(styles.spanBox, "flex_box align_center")}>
					<FieldTimeOutlined
						style={{
							color: "#722ed1",
						}}
					/>
					<i>{moment(data.updateTime).format("YYYY-MM-DD")}</i>
				</div>
			</Tooltip>
			<i>|</i>
			{
				isShowView && <React.Fragment>
					<Tooltip title={intl.get("Views") + data.viewTimes}>
						<div className={classNames(styles.spanBox, "flex_box align_center")}>
							<EyeOutlined
								style={{
									color: "#62c92f",
								}}
							/>
							<i>{data.viewTimes}</i>
						</div>
					</Tooltip>
					<i>|</i>
				</React.Fragment>
			}

			<div>
				<Tooltip title={intl.get("Collections") + data.collectTimes}>
					<div onClick={handelCollect} className={classNames(styles.spanBox, "flex_box align_center")}>
						{data.isFavorite ?
							<StarFilled
								style={{
									color: "#d62293",
								}}
							/>
							:
							<StarOutlined
								style={{
									color: "#d62293",
								}}
							/>
						}
						<i>{data.collectTimes}</i>
					</div>
				</Tooltip>
			</div>
			<i>|</i>
			<Tooltip title={intl.get("Downloads") + data.downloadTimes}>
				<div className={classNames(styles.spanBox, "flex_box align_center")}>
					<CloudDownloadOutlined
						style={{
							color: "#5AB6F9",
						}}
					/>
					<i>{data.downloadTimes}</i>
				</div>
			</Tooltip>
		</div>
	</Card>
}
export default ResourceCard;